import {Component, Input, OnInit} from '@angular/core';
import {FormModel} from '../../../../common/components/form/models';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';
import {TypeDemandes} from '../type-demandes.enum';

@Component({
  selector: 'app-responses-status-summary',
  templateUrl: './responses-status-summary.component.html',
  styleUrls: ['./responses-status-summary.component.scss']
})
export class ResponsesStatusSummaryComponent implements OnInit {
  @Input() listForms: FormModel[] = [];
  typeDemandes = TypeDemandes;
  total_traitees = 0;
  total_traitement = 0;
  total_incomplet = 0;
  total_archivees = 0;
  total_attente = 0;
  constructor(public formSvc: FormulaireService) { }

  ngOnInit(): void {
    this._calculTotals();
  }
  private _calculTotals() {
    this.listForms.forEach(_form => {
      this.total_traitees += this.formSvc.calculateCountResponseByState(_form.responses_count, TypeDemandes.Traitees);
      this.total_traitement += this.formSvc.calculateCountResponseByState(_form.responses_count, TypeDemandes.En_traitement);
      this.total_archivees += this.formSvc.calculateCountResponseByState(_form.responses_count, TypeDemandes.Archivees);
      this.total_incomplet += this.formSvc.calculateCountResponseByState(_form.responses_count, TypeDemandes.Incomplet);
      this.total_attente += this.formSvc.calculateCountResponseByState(_form.responses_count, TypeDemandes.En_attente);
    });
  }

}
